import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getAllContractTemplates(_obj, params) {
    const res = await axios.get('api/contracts/templates/', { params });
    return res.data;
  },
  async getContractTemplate(_obj, id) {
    const res = await axios.get(`api/contracts/templates/${id}/`);
    return res.data;
  },
  async createContractTemplate(_obj, data) {
    return axios.post('api/contracts/templates/', data);
  },
  async updateContractTemplate(_obj, { id, data }) {
    return axios.patch(`api/contracts/templates/${id}/`, data);
  },
  async deleteContractTemplate(_obj, id) {
    return axios.delete(`api/contracts/templates/${id}/`);
  },
};

export const contractTemplate = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
